<footer class="help-footer" aria-label="Support links">
  <a class="help-contact" href="https://wa.me/27210101574" target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp: 021 010 1574" (click)="onWhatsappClick('need_help')">
    <mat-icon svgIcon="whatsapp" aria-hidden="true"></mat-icon>
    <span>Need help?</span>
  </a>

  <a class="phone-link" href="https://wa.me/27210101574" target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp: 021 010 1574" (click)="onWhatsappClick('phone_number')">021 010 1574</a>

  <a class="faq-link" href="https://www.paxi.co.za/paxi-frequently-asked-questions" target="_blank" rel="noopener noreferrer" aria-label="Open FAQs" (click)="onFaqClick()">
    FAQs
    <mat-icon aria-hidden="true">chevron_right</mat-icon>
  </a>
</footer>
